import { Button, Panel } from "@mixitone/components";
import { ClubDocument } from "@mixitone/models";
import { ApplicationView } from "@mixitone/mvc";
import { DashLayout } from "Components/DashLayout";
import { ClubController } from "controllers/ClubController";
import { PortalController } from "controllers/PortalController";
import { PdfView } from "./PdfView";
import { formatDate } from "@mixitone/util";
import { Link } from "react-router-dom";
import { buttonClasses } from "@mixitone/components/Styles/Buttons";

interface State {
  loading: boolean;
  documents: ClubDocument[];
  showDocument: ClubDocument | null;
}

class ClubDocumentsPageController extends PortalController<State> {
  get initialState(): State {
    return {
      loading: true,
      documents: [],
      showDocument: null,
    };
  }

  async initialize() {
    const club = this.get(ClubController).state.club;
    const documents = await ClubDocument.query().eq("club_id", club.id).all();
    this.state.documents = ClubDocument.onlyLastVersion(documents);
  }

  actionShowDocument(document: ClubDocument) {
    this.state.showDocument = document;
  }

  actionHideDocument() {
    this.state.showDocument = null;
  }
}

const ControlledClubDocumentsPage = () => {
  const controller = ClubDocumentsPageController.use();
  const { documents, loading, showDocument } = controller.state;
  const clubController = ClubController.use();
  const { club } = clubController.state;

  return (
    <DashLayout title={club.name}>
      <div className="flex flex-col gap-6 pb-6">
        <Link to={".."} className={buttonClasses({ kind: "link" })}>
          Back to club
        </Link>
        <Panel title="Club documents" titleClassName="font-semibold">
          <div className="flex flex-col gap-4">
            {documents.map((doc) => (
              <Button kind="link" key={doc.id} onClick={() => controller.actionShowDocument(doc)}>
                <span className="flex items-center justify-between w-full">
                  <span>
                    {doc.name}
                    {doc.version && ` v${doc.version}`}
                  </span>
                  <span>{formatDate(doc.created_at)}</span>
                </span>
              </Button>
            ))}
          </div>
        </Panel>
      </div>
      {showDocument && (
        <PdfView document={showDocument} required={false} onClose={() => controller.actionHideDocument()} />
      )}
    </DashLayout>
  );
};

export const ClubDocumentsPage = ClubDocumentsPageController.scope(
  ApplicationView(ControlledClubDocumentsPage),
);
